import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

interface UpdateAvailableToastProps {
  /** package.json version of the new build; omitted when the deploy didn't bump it. */
  version?: string;
  onRefresh: () => void;
  onLater: () => void;
}

export const UpdateAvailableToast: React.FC<UpdateAvailableToastProps> = ({
  version,
  onRefresh,
  onLater,
}) => (
  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
    <SystemUpdateAltIcon color='primary' sx={{ mt: 0.25 }} />
    <Box sx={{ flex: 1 }}>
      <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
        {version ? `NexGen v${version} is available` : 'An update is available'}
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
        Refresh to get the latest version.
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
        <Button size='small' variant='contained' onClick={onRefresh}>
          Refresh now
        </Button>
        <Button size='small' onClick={onLater}>
          Later
        </Button>
      </Box>
    </Box>
  </Box>
);
